
import { mapMutations } from 'vuex'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'HbA1c',
components: {
XTable
},
data () {
return {
form: {
ifcc: '',
dcct: '',
eag1: '',
eag: ''
},
disabled: false,
name: ''
}
},
watch: {
form: {
handler: function (newVal) {
console.log(newVal, 'newVal')
},
deep: true
}
},
created () {
this.hideLoad()
},
methods: {
...mapMutations(['hideLoad']),
changeHandler (e) {
this.name = e
},
clickHandler () {
this.inputBlur(this.name)
},
reset () {
this.form = {
ifcc: '',
dcct: '',
eag1: '',
eag: ''
}
},
inputBlur (name) {
if (name === 'ifcc') {
this.form.dcct = ((Number(this.form.ifcc) / 10.929) + 2.15).toFixed(2).toString()
this.form.eag1 = (28.7 * (((Number(this.form.ifcc) / 10.929) + 2.15)) - 46.7).toFixed(2).toString()
this.form.eag = (((28.7 * ((this.form.ifcc / 10.929) + 2.15)) - 46.7) / 18).toFixed(2).toString()
if (this.form.ifcc === '') {
this.reset()
}
} else if (name === 'dcct') {
this.form.ifcc = ((this.form.dcct - 2.15) * 10.929).toFixed(2).toString()
this.form.eag1 = (28.7 * this.form.dcct - 46.7).toFixed(2).toString()
this.form.eag = ((28.7 * this.form.dcct - 46.7) / 18).toFixed(2).toString()
if (this.form.dcct === '') {
this.reset()
}
} else if (name === 'eag1') {
this.form.eag = (this.form.eag1 / 18).toFixed(2).toString()
this.form.dcct = (((this.form.eag1 / 18) + 2.5944) / 1.5944).toFixed(2).toString()
this.form.ifcc = (((((this.form.eag1 / 18) + 2.5944) / 1.5944) - 2.15) * 10.929).toFixed(2).toString()
if (this.form.eag1 === '') {
this.reset()
}
} else if (name === 'eag') {
this.form.eag1 = (this.form.eag * 18).toFixed(2).toString()
this.form.dcct = ((((this.form.eag * 18) / 18) + 2.5944) / 1.5944).toFixed(2).toString()
this.form.ifcc = ((((((this.form.eag * 18) / 18) + 2.5944) / 1.5944) - 2.15) * 10.929).toFixed(2).toString()
if (this.form.eag === '') {
this.reset()
}
}
console.log(this.form)
}
},
computed: {

}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/HbA1c.vue